import { mergeWith } from 'lodash';

const mutations = {
  setName: (state, name) => {
    state.meta.name = name;
  },

  setList: (state, list) => {
    state.list = list;
  },
  setPageInfo: (state, pageInfo) => {
    state.pageInfo = pageInfo;
  },
  setConditions: (state, params) => {
    state.params = params;
  },
  setDetail: (state, data) => {
    state.detail = data;
  },
  flushDetail: (state, data) => {
    state.detail = {
      storeNo: 0,
      userNo: 0,
      userId: '',
      storeCategoryNo: 0,
      storeTypeNo: 0,
      locationNo: 0,
      owner: 0,
      phone: '01012341234',
      nameKr: 0,
      nameVn: 0,
      address: '',
      addressDetail: '',
      tagVn: '',
      tagKr: '',
      blog: '',
      youtube: '',
      hasOffline: true,
      isActive: true,
      isShow: true,
      isWork: true,
      isDeliverable: true,
      isChattable: true,
      isQueryable: true,
      isSupportDelivery: true,
      isSupportPacking: true,
      isSupportVisit: true,
      isViaCash: true,
      isViaCard: true,
      isViaAutomaticWithdrawal: true,
      isViaOnlinePayment: true,
      isPointAvailable: true,
      introduceKr: '',
      introduceVn: '',
      noticeKr: '',
      noticeVn: '',
      regDate: '',
      updateDate: '',
      supportLanguage: '',
      baseDeliveryFee: 0,
      baseDeliveryFeeLimit: 0,
      increaseDeliveryFeePer: 0,
      additionalDeliveryFee: 0,
      maximumDeliveryFee: 0,
      noDeliveryFeeWhen: 0,
      minimumPriceForDelivery: 0,
      minimumDeliveryDuration: 0,
      maximumDeliveryDuration: 0,
      ifAcceptDelivery: 0,
      exceedMinutes: 0,
      discountWhenPack: 0,
      orderCommissions: 0.0,
      lastCommissionModifiedDate: '',
      latitude: '',
      longitude: '',
      storeNoticeKr: '',
      storeNoticeVn: '',
      storeAccounts: [
        { bank: '', accountNumber: '', depositHolder: '' },
        { bank: '', accountNumber: '', depositHolder: '' }
      ],
      businessDays: [],
      breakTimes: [],
      holidays: [],
      serviceableAreas: [],
      files: [],
      rawFiles: [],

      storeType: {
        storeTypeNo: null,
        typeKr: '',
        typeVn: '',
        regDate: '',
        isActive: true
      },
      storeCategory: {
        storeCategoryNo: null,
        categoryKr: '',
        categoryVn: '',
        regDate: '',
        isActive: true
      },
      totalBizMoney: 0,
      avgStar: 0.0,
      reviewCount: 0,
      replCount: 0,
      favStoreCount: 0,
      favProductCount: 0,
      totalOrderCount: 0
    };
  },
  setBasic: (state, data = { phone: '', hasOffline: false, tagVn: '', tagKr: '', blog: '', youtube: '' }) => {
    state.detail.phone = data.phone;
    state.detail.hasOffline = data.hasOffline;
    state.detail.tagVn = data.tagVn;
    state.detail.tagKr = data.tagKr;
    state.detail.blog = data.blog;
    state.detail.youtube = data.youtube;
  },
  setBusiness: (
    state,
    data = {
      isShow: false,
      isWork: false,
      isDeliverable: false,
      isChattable: false,
      isQueryable: false,
      businessDays: [],
      breakTimes: [],
      holidays: [],
      minimumDeliveryDuration: 0,
      maximumDeliveryDuration: 0,
      isSupportDelivery: 0,
      isSupportPacking: 0,
      isSupportVisit: 0,
      ifAcceptDelivery: 0,
      exceedMinutes: 0,
      discountWhenPack: 0
    }
  ) => {
    state.detail.isShow = data.isShow;
    state.detail.isWork = data.isWork;
    state.detail.isDeliverable = data.isDeliverable;
    state.detail.isChattable = data.isChattable;
    state.detail.isQueryable = data.isQueryable;
    state.detail.businessDays = data.businessDays;
    state.detail.breakTimes = data.breakTimes;
    state.detail.holidays = data.holidays;
    state.detail.minimumDeliveryDuration = data.minimumDeliveryDuration;
    state.detail.maximumDeliveryDuration = data.maximumDeliveryDuration;
    state.detail.isSupportDelivery = data.isSupportDelivery;
    state.detail.isSupportPacking = data.isSupportPacking;
    state.detail.isSupportVisit = data.isSupportVisit;
    state.detail.ifAcceptDelivery = data.ifAcceptDelivery;
    state.detail.exceedMinutes = data.exceedMinutes;
    state.detail.discountWhenPack = data.discountWhenPack;
  },
  setPayment: (state, data) => {
    const { isViaCash, isViaCard, isViaAutomaticWithdrawal, isViaOnlinePayment, storeAccounts, isPointAvailable } =
      data;

    state.detail.isViaCash = isViaCash;
    state.detail.isViaCard = isViaCard;
    state.detail.isViaAutomaticWithdrawal = isViaAutomaticWithdrawal;
    state.detail.isViaOnlinePayment = isViaOnlinePayment;
    state.detail.storeAccounts = storeAccounts;
    state.detail.isPointAvailable = isPointAvailable;
  },
  setNotices: (state, { introduceKr, introduceVn, storeNoticeKr, storeNoticeVn }) => {
    state.detail.introduceKr = introduceKr;
    state.detail.introduceVn = introduceVn;
    state.detail.storeNoticeKr = storeNoticeKr;
    state.detail.storeNoticeVn = storeNoticeVn;
  },
  setSavedImages: (state, data) => {
    state.detail.rawFiles = [];
    state.detail.files = data;
  },
  setTips: (state, data) => {
    state.detail.baseDeliveryFee = data.baseDeliveryFee;
    state.detail.baseDeliveryFeeLimit = data.baseDeliveryFeeLimit;
    state.detail.increaseDeliveryFeePer = data.increaseDeliveryFeePer;
    state.detail.additionalDeliveryFee = data.additionalDeliveryFee;
    state.detail.maximumDeliveryFee = data.maximumDeliveryFee;
    state.detail.noDeliveryFeeWhen = data.noDeliveryFeeWhen;
  },
  setServiceableArea: (state, data = []) => {
    state.serviceableAreas = data;
  }
};
export default mutations;
